<template>
	<div
		:class="classes"
		:style="style"
		class="pane"
	>
		<transition name="fade" mode="out-in">
			<div
				:key="transitionKey"
				:class="innerClasses"
				class="pane-inner"
			>
				<slot/>
			</div>
		</transition>
	</div>
</template>

<script>
import layerMixin from './layerMixin.js';
export default {
	name: 'TPane',
	mixins: [layerMixin],
	computed: {
		classes() {
			return [
				this.background ? `background-${this.background}` : '',
				this.elevation ? `elevation-${this.elevation}` : '',
				this.elevationActive ? `elevation-active-${this.elevationActive}` : '',
				this.elevationHover ? `elevation-hover-${this.elevationHover}` : '',
				this.border ? `border-${this.border}` : '',
				this.borderTop ? `border-top-${this.borderTop}` : '',
				this.borderRight ? `border-right-${this.borderRight}` : '',
				this.borderBottom ? `border-bottom-${this.borderBottom}` : '',
				this.borderLeft ? `border-left-${this.borderLeft}` : '',
			];
		},
		style() {
			return {
				borderRadius: this.borderRadius,
				height: this.height,
				width: this.width,
			};
		},
		innerClasses() {
			return [this.center ? 'center' : '',];
		}
	}
};
</script>

<style lang="scss" scoped>
@import './scss/mixins';
@import './scss/pane';
@import './scss/transition';
</style>


<docs>
## Examples

### Elevations
```jsx noeditor
<div style="display: inline-grid; grid-column-gap: 50px; grid-template-columns: repeat(5, auto);">
	<t-pane background="tint1" elevation="0" elevationHover="0" height="100px" width="100px" center>Elevation 0</t-pane>
	<t-pane background="tint1" elevation="1" elevationHover="1" height="100px" width="100px" center>Elevation 1</t-pane>
	<t-pane background="tint1" elevation="2" elevationHover="2" height="100px" width="100px" center>Elevation 2</t-pane>
	<t-pane background="tint1" elevation="3" elevationHover="3" height="100px" width="100px" center>Elevation 3</t-pane>
	<t-pane background="tint1" elevation="4" elevationHover="4" height="100px" width="100px" center>Elevation 4</t-pane>
</div>
```

#### Example Code
```html
	<t-pane background="tint1" elevation="2" elevationHover="2" center>Elevation 2</t-pane>
```

### Borders
```jsx noeditor
<div style="display: inline-grid; grid-row-gap: 30px; grid-column-gap: 50px; grid-template-columns: repeat(5, auto);">
	<t-pane background="tint1" borderTop="default" height="100px" width="100px" center>Top Default</t-pane>
	<t-pane background="tint1" borderRight="default" height="100px" width="100px" center>Right Default</t-pane>
	<t-pane background="tint1" borderBottom="default" height="100px" width="100px" center>Bottom Default</t-pane>
	<t-pane background="tint1" borderLeft="default" height="100px" width="100px" center>Left Default</t-pane>
	<t-pane background="tint1" border="default" height="100px" width="100px" center>All Default</t-pane>

	<t-pane background="tint1" borderTop="muted" height="100px" width="100px" center>Top Muted</t-pane>
	<t-pane background="tint1" borderRight="muted" height="100px" width="100px" center>Right Muted</t-pane>
	<t-pane background="tint1" borderBottom="muted" height="100px" width="100px" center>Bottom Muted</t-pane>
	<t-pane background="tint1" borderLeft="muted" height="100px" width="100px" center>Left Muted</t-pane>
	<t-pane background="tint1" border="muted" height="100px" width="100px" center>All Muted</t-pane>
</div>
```

#### Example Code
```html
	<t-pane background="tint1" borderRight="default" center>Right Default</t-pane>
	<t-pane background="tint1" borderRight="muted" center>Right Muted</t-pane>
	<t-pane background="tint1" border="default" center>All Default</t-pane>
	<t-pane background="tint1" border="muted" center>All Muted</t-pane>
```
</docs>
